import ScoringWizardStepTwo, { validator } from './ScoringWizardStepTwo'

export { validator }
export default ScoringWizardStepTwo
